FD.AJAX = (function ($, me) {
    'use strict';

    var child = {};
    var ajaxOutstanding = [];
    var ajaxScheduled = [];
    var originalLoadingElements = [];
    var notify;

    /* ========================================================================
     *  private methods
     * ========================================================================
    */


    //  get ajax options
    function getAjaxOptions() {
        return {
            data: '',
            params: {},
            callback: '',
            url: "",
            ishtml: false,
            isloader: false,
            tag: 0,
            success: false,
            cancelprevious: false,
            delay: false,
            processData: true,
            loadingElements: null, // can be jquery object of element(s), or array of elements
            contentType: 'application/json; charset=utf-8' //   for form submits, we want to use 'application/x-www-form-urlencoded; charset=UTF-8'
        };
    }


    function handleAjaxQueue(url, ajaxCall) {
        for (var i = ajaxOutstanding.length - 1; i >= 0; i--) {
            var ajaxObj = ajaxOutstanding[i];

            //  remove any done calls
            if (ajaxObj.xhr.readyState === 4) {
                ajaxOutstanding.splice(i, 1);
                continue;
            }

            //  if there's a repeat, kill the previous
            if (ajaxObj.url === url) {
                ajaxObj.xhr.abort();
                ajaxOutstanding.splice(i, 1);
            }
        }

        ajaxOutstanding.push({
            url: url,
            xhr: ajaxCall
        });
    }

    function handleAjaxSchedule(options) {
        var item;

        for (var i = ajaxScheduled.length - 1; i >= 0; i--) {
            item = ajaxScheduled[i];

            if (item.name === options.url) {
                clearTimeout(item.timeout);
                ajaxScheduled.splice(i, 1);
            }
        }

        item = {
            name: options.url,
            timeout: setTimeout(function () {
                doAJAX(options);
            }, 500)
        };

        ajaxScheduled.push(item);
    }

    function handleLoadingElementReset() {
        for (var i = 0; i < originalLoadingElements.length; i++) {
            originalLoadingElements[i].elemObj.removeClass('disabled').prop('disabled', false).html(originalLoadingElements[i].originalHTML);
        }
    }

    function fixJsFunctions(data) {
        jQuery.each(data, function (index, value) {
            if (typeof value == 'object') {
                fixJsFunctions(value);
            }
            else if(typeof value == 'string') {
                if (value.indexOf("function(") > -1)
                    data[index] = eval("(" + value + ")");
            }
        });
    };


    //  do ajax
    function doAJAX(options) {
        var label = me.getLabel();
        var dataType = options.ishtml ? "html" : "json";
        options.defer = $.Deferred();

        //  loading elements
        if (options.loadingElements && (options.loadingElements instanceof jQuery || options.loadingElements instanceof Array)) {
            $.each(options.loadingElements, function () {
                var item = {};
                item.elemObj = $(this);
                item.elemObj.find('img').attr('onerror', ''); //    avoid possible script execution 
                item.originalHTML = $.parseHTML(item.elemObj.html());
                item.elemObj.addClass('disabled').prop('disabled', true).html('<i class="fa fa-fw fa-spinner fa-spin"></i>');
                originalLoadingElements.push(item);
            });
        }

        var ajaxCall = $.ajax({
            url: options.url,
            async: options.async === undefined ? true : options.async,
            data: (options.contentType === 'application/json; charset=utf-8') ? JSON.stringify(options.params) : options.params,
            type: 'POST',
            dataType: dataType,
            contentType: options.contentType,
            processData: options.processData,
            beforeSend: function () {
                if (options.isloader) {
                    me.setTopProgressBar();
                }
            },
            headers: {
                "ClientDateTime": moment().format("YYYY-MM-DD HH:mm:ss.SSS"),
                "ClientTimeZone": moment().format("z")
            }
        }).done(function (data, status, xhr) {
            if (!options.ishtml && xhr.responseText.indexOf("\"function(") > -1) {
                fixJsFunctions(data);
            }
            options.data = data;
            options.success = true;
            options.date = new Date();
            options.currenturl = location.href;
            options.getResponseHeader = xhr.getResponseHeader;

            if (data === 'false') {
                notify = notify || new Notify();
                notify.options.delay = 2500;
                notify.alert(label["YourRequestCouldNotBeCompletedPleaseTryAgain"]);

                me.setModalLock(false);
            }
            if (options.isloader) {
                me.unsetTopProgressBar();
            }
            if (typeof options.callback === 'function') {
                options.callback(options);
            } else {
                if (options.data === 'false') {
                    options.defer.reject(options);
                } else {
                    options.defer.resolve(options.data)
                }
            }
            if (options.loadingElements) {
                handleLoadingElementReset();
            }
            $("[role=tooltip]").each(function () {
                if ($($(this).data()['bs.tooltip'].element).closest(document.documentElement).length == 0) {
                    $($(this).data()['bs.tooltip'].element).tooltip('hide');
                }
            });
        }).fail(function (jqXhR, textStatus, errorThrown) {
            options.dataError = jqXhR;
            options.errorStatus = textStatus;
            options.errorMsg = errorThrown;
            options.date = new Date();
            options.data = false;
            options.currenturl = location.href;

            me.setModalLock(false);

            if (typeof options.callback === 'function') {
                options.callback(options);
            } else {
                options.defer.reject(options);
            }
            if (options.isloader) {
                me.unsetTopProgressBar();
            }
            if (options.loadingElements) {
                handleLoadingElementReset();
            }
            if (typeof setAjaxFail === 'function') {
                if (jqXhR.status === 0) {
                    return;
                }

                setAjaxFail(jqXhR, this, options);
                return;
            }
        });

        if (options.cancelprevious) {
            handleAjaxQueue(options.url, ajaxCall);
        }
        if (typeof options.xhr === 'function') {
            options.xhr(ajaxCall);
        }
        return options.defer.promise();
    }


    //  get ajax
    function getAJAX(options) {
        if (options.delay) {
            handleAjaxSchedule(options);
        } else {
            return doAJAX(options);
        }
    }


    //  set ajax fail
    function setAjaxFail(jqXhR, rspnse, data) {
        var label = me.getLabel();
        notify = notify || new Notify();
        $(this).closest('form').removeClass('form-processing');

        var message = jqXhR.status == 400 ? jqXhR.getResponseHeader('error-message') : label.AnErrorHasOccurredISTeamNotified;

        notify.alert(message);
    }


    /* ========================================================================
     *  public methods
     * ========================================================================
    */

    //  set ajax [ used in all data cases]
    child.setAJAX = function (options) {
        var defaults = getAjaxOptions(),
            opts = $.extend({}, defaults, options);
        return getAJAX(opts);
    };

    $(document).on("change", "[data-update=OnFieldChange] input,[data-update=OnFieldChange] select,[data-update=OnFieldChange] textarea", function () {
        if ($(this).data("update") !== "ignore") {
            var form = $(this).closest("form");
            setTimeout(function () {
                // Delay posting the form a tic so that field event handlers can run.
                $('[data-disabled=ignore]', form).attr('disabled', false);
                form.submit();
                $('[data-disabled=ignore]', form).attr('disabled', true);
            }, 1);
        }
    });
    $(document).on("click", "[data-update=OnFieldChange] button[type=submit]", function () {
        if ($(this).data("update") !== "ignore") {
            var form = $(this).closest("form");
            $('[data-disabled=ignore]', form).attr('disabled', false);
            setTimeout(function () {
                $('[data-disabled=ignore]', form).attr('disabled', true);
            }, 1);
        }
    });

    child.onFailure = setAjaxFail;

    child.showModal = function (xhr) {
        var modal = $(this).data("ajaxUpdate") ? $($(this).data("ajaxUpdate")) : $('#IS_MODAL');
        me = FD;

        modal.off().on('shown.bs.modal', function () {
            me.CONTROL.setValidateContainer();
            modal.enableControls();

            me.setModalLock(false);

            if ($("[data-update=OnFieldChange]", modal).length) {
                $("[data-update=OnFieldChange]", modal).each(function () {
                    var form = $(this);
                    $("[data-fd=datepicker]", "#IS_MODAL").each(function () {
                        var func = $(this).datepicker("option", "onSelect");
                        $(this).datepicker("option", "onSelect", function (dT, ui) {
                            if (func) {
                                func.call(this, dT, ui);
                            }
                            $(form).submit();
                        });
                    });
                });
            }
            $("form", modal).submit(function () {
                if (!$(this).valid()) {
                    $(this).validate().focusInvalid();
                    return false;
                }
            });


        }).on('hidden.bs.modal', function () {
            me.setToolTip();
            if ($("[data-onclose]", modal).data('onclose')) {
                eval($("[data-onclose]", modal).data('onclose')).call(modal);
            }
        }).modal('show');
    };

    child.hideModal = function (xhr, textStatus, callback) {
        var modal = $(this).data("ajaxUpdate") ? $($(this).data("ajaxUpdate")) : $('#IS_MODAL');

        if (typeof callback == "function") {
            modal.off('hidden.bs.modal').on('hidden.bs.modal', callback);
        }

        modal.modal('hide');
    };

    //child.addRow
    child.updateRow = function (target, data) {
        $(target).html($(data).html()).enableControls();
    };

    child.removeRow = function (xhr) {
        var parentTable = $(this).closest("table");

        $(this).closest("[data-parentid]").remove();
        $("[data-noresults]", parentTable).toggleClass("hidden", $("[data-parentid]", this).length > 0);
    };

    /* ========================================================================
     *  return
     * ========================================================================
    */
    return child;
}(jQuery, FD));